function ConfirmIdentityStep() {
    var self = this;
    BaseStepModel.apply(self, ['confirm_identity_panel']);

    self.isLoadingRegistrationFields = ko.observable(true);
    self.registrationFieldGroups = ko.observable([]);
    self.numberDigitsToValidateTaxId = ko.observable(null);
    self.minimumNumberDigitsToValidateTaxId = ko.observable(null);
    self.isButtonDisabled = ko.observable(false);

    self.currentField = ko.observable(null);

    self.editField = function (field) {
        field.fieldTempValue(field.fieldValue());
        self.currentField(field);
        registrationArea.showConfirmIdentityEditFieldPanel(field.fieldTypeName === 'List' ? field.labelText : null);

        if (field.fieldTempValue() !== null && field.fieldTempValue() !== '')
            self.currentField().isValid();

        self.currentField().isEditing(true);
    };

    self.selectListItem = function (listItem) {
        self.currentField().fieldTempValue(listItem.DefaultValue);
        self.done();
    };

    self.done = function () {
        if (self.currentField().isValid()) {
            self.currentField().fieldValue(self.currentField().fieldTempValue());

            if (self.hasValidationErrors()) {
                // Refresh the validation errors.
                self.isValid();
            }

            registrationArea.showConfirmIdentityPanel();
            self.currentField(null);
        }
    };

    self.isValid = function () {
        var errors = [];

        $.each(self.registrationFieldGroups(), function (i, group) {
            $.each(group.fieldsWithoutValues(), function (j, field) {
                if (field.fieldInfo.IsRequired) {
                    errors.push(field.labelText + ' is required.');
                }
            });
        });

        self.validationErrors(errors);

        return self.validationErrors().length === 0;
    };

    self.confirmIdentity = function () {
        var $form = $('#registration_fields_form');

        if (self.isValid()) {
            self.isButtonDisabled(true);

            $.ajax({
                url: $form.attr('action'),
                type: "POST",
                data: $form.serialize(),
                success: function (result) {
                    self.isButtonDisabled(false);

                    if (result.isValid) {
                        self.isDone(true);
                    } else {
                        self.validationErrors(result.error_messages);
                        $('#confirm_identity_panel').scrollTop(0);
                    }
                },
                error: function () {
                    self.isButtonDisabled(false);
                    self.validationErrors([Alkami.Localization.SiteText['ShortGeneralErrorMessage']]);
                    $('#confirm_identity_panel').scrollTop(0);
                }
            });
        }

        if (self.hasValidationErrors()) {
            $('#confirm_identity_panel').scrollTop(0);
        }
    };

    self.show = function () {
        self.resetState();
        self.isButtonDisabled(false);
        registrationArea.showConfirmIdentityPanel();
    };

    self.loadRegistrationFields = function (isBusiness) {
        $.ajax({
            type: 'GET',
            url: '/Mobile/Registration/Information?isBusiness=' + isBusiness,
            success: function (data) {

                self.isLoadingRegistrationFields(false);
                self.numberDigitsToValidateTaxId(data.NumberDigitsToValidateTaxId);
                self.minimumNumberDigitsToValidateTaxId(data.MinimumNumberDigitsToValidateTaxId);

                var regGroups = [];

                if (data.RegistrationFieldGroups) {
                    $.each(data.RegistrationFieldGroups, function (i, group) {
                        var regGroup = new RegistrationFieldGroup();
                        regGroup.name = group[0].RegistrationFieldGroup.Name;
                        regGroup.description = group[0].RegistrationFieldGroup.Description;

                        var regFields = [];

                        $.each(group, function (j, field) {
                            regFields.push(new RegistrationField(field, data.RegistrationFieldTypes, data.RegistrationTypes, data.RegistrationFieldListItems));
                        });

                        regGroup.fields(regFields);

                        regGroups.push(regGroup);
                    });

                    self.registrationFieldGroups(regGroups);
                }
            },
            error: function (request, status, error) {
                self.isLoadingRegistrationFields(false);
            }
        });
    }
}